module.exports = __webpack_public_path__ + "Poppins-ExtraBoldItalic.0a514a668001f8e3f6fe.woff";


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/src/assets/vendors/base/fonts/googleapi-fonts/Poppins-ExtraBoldItalic.woff
// module id = ../../../../../src/assets/vendors/base/fonts/googleapi-fonts/Poppins-ExtraBoldItalic.woff
// module chunks = styles